<template>
  <div
    :style="sizeStyle"
    class="bg-main rounded-full flex items-center justify-center overflow-hidden"
    aria-hidden="true"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      :width="svgSize"
      :height="svgSize"
      fill="rgba(251,251,251,1)"
    >
      <path
        d="M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H18C18 18.6863 15.3137 16 12 16C8.68629 16 6 18.6863 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  // size can be a Number (pixels) or a String with CSS units (e.g. "2rem", "40px", "100%")
  size: {
    type: [Number, String],
    default: '100%',
  },
})

const sizeStyle = computed(() => {
  if (typeof props.size === 'number') {
    return {
      width: `${props.size}px`,
      height: `${props.size}px`,
    }
  }
  // assume string includes units (like "2rem", "40px", "100%")
  return {
    width: props.size,
    height: props.size,
  }
})

// SVG should scale well inside the avatar; if numeric size provided, use half for the icon
const svgSize = computed(() => {
  if (typeof props.size === 'number') return Math.max(12, Math.floor(props.size * 0.5))
  return '50%'
})
</script>
